export default "__VITE_ASSET__b23c48f6__"